"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': 'Ukończone',
    'tutorial.todos.pending': 'Oczekujące',
    'tutorial.todos.markCompleted': 'Oznacz jako ukończone',
    'tutorial.todos.markPending': 'Oznacz jako oczekujące',
    'tutorial.todos.statusDone': 'wykonane',
    'tutorial.todos.statusUndone': 'niewykonane',
    'tutorial.todos.changeComment.1': 'Zmieniłeś status zadania „{name}” na: {status}.',
    'tutorial.todos.changeComment.2': 'Zadanie „{name}” – {status}. Przyjąłem do wiadomości.',
    'tutorial.todos.changeComment.3': 'Odnotowałem zmianę: zadanie „{name}” jest teraz {status}.',
    'tutorial.todos.changeComment.4': 'Zapisane! Zadanie „{name}” oznaczone jako {status}.',
    'tutorial.audio.stop': 'Zatrzymaj',
    'tutorial.audio.pause': 'Pauza',
    'tutorial.audio.play': 'Odtwórz',
    'tutorial.audio.volume': 'Głośność',
    'tutorial.audio.writingSpeed': 'Szybkość pisania',
    'tutorial.audio.writingSpeed.normal': 'Normalna',
    'tutorial.audio.writingSpeed.fast': 'Szybka',
    'tutorial.audio.writingSpeed.veryFast': 'Bardzo szybka',
};
